import type { ApiRoutes } from '@tempo-io/audit-app/rpc';
import { hc } from 'hono/client';
import type { KyInstance } from 'ky';

export const getAuditServiceApi = ({
  prefixUrl = '',
  client, // should include bearer token hook
}: {
  prefixUrl?: string;
  client: KyInstance;
}) =>
  hc<ApiRoutes>('/api/audit/v1/', {
    fetch: (input: RequestInfo | URL, requestInit?: RequestInit) => {
      return client(`${prefixUrl}${input}`, {
        method: requestInit?.method,
        headers: {
          'content-type': 'application/json',
          ...requestInit?.headers,
        },
        body: requestInit?.body,
      });
    },
  });
